<template>
  <a-spin :tip="loadingTip" :spinning="isloading" >
    <div>
        <a-tabs :defaultActiveKey="1" :activeKey="activeTabKey" @change="tabcallback">
            <a-tab-pane :key="1" tab="基本信息" force-render>
                <basicInfo v-if="basicInfo" @callbackMethod="setProjectId" :id="projectId"/>
            </a-tab-pane>
            <a-tab-pane :key="2" tab="课程信息" force-render :disabled="projectId==0">
                <courseInfo v-if="courseInfo" :projectId="projectId" />
            </a-tab-pane>
            <a-tab-pane :key="3" tab="考试列表" forceRender :disabled="projectId==0">
                <testList v-if="testList" :projectId="projectId"/>
            </a-tab-pane>
            <a-tab-pane :key="4" tab="结业证书" forceRender :disabled="projectId==0">
                <certificate v-if="certificate" :projectId="projectId"/>
            </a-tab-pane>
            <!-- <a-tab-pane key="5" tab="学习资料" forceRender :disabled="projectId==0">
                <studyFile v-if="studyFile" :projectId="projectId"/>
            </a-tab-pane> -->
        </a-tabs>
    </div>
  </a-spin>
</template>

<script>
var that;
import basicInfo from "./basicInfo.vue"; //基本信息
import courseInfo from "./courseList.vue"; //课程信息
import testList from "./testList.vue"; //考试列表
import certificate from "./certificateList.vue"; //结业证书
import studyFile from "./studyFile.vue"; //学习资料

export default {
  props: {
    id: String,
  },
  data() {
    return {
      activeTabKey:1,
      projectId:"0",
      basicInfo: true,
      courseInfo: false,
      testList: false,
      certificate: false,
      studyFile: false,
      form: this.$form.createForm(this),
      isloading: false,
      loadingTip: "加载中...",
    };
  },
  components: {
    basicInfo,
    courseInfo,
    testList,
    certificate,
    studyFile
  },
  mounted() {
    this.$nextTick(function() {
      this.projectId=this.id?this.id:"0";
    });
  },
  methods: {
    sumbit() {
      this.$emit("callbackMethod");
    },
    setProjectId(id){
      this.projectId=id;
      console.log("id",id)
      this.tabcallback(2);
    },
    //tab切换
    tabcallback(key) {
      this.activeTabKey=key;
      if (key == 1) {
        this.basicInfo = true;
        this.courseInfo = false;
        this.testList = false;
        this.certificate = false;
        this.studyFile = false;
      } else if (key == 2) {
        this.basicInfo = false;
        this.courseInfo = true;
        this.testList = false;
        this.certificate = false;
        this.studyFile = false;
      } else if (key == 3) {
        this.basicInfo = false;
        this.courseInfo = false;
        this.testList = true;
        this.certificate = false;
        this.studyFile = false;
      }else if (key == 4) {
        this.basicInfo = false;
        this.courseInfo = false;
        this.testList = false;
        this.certificate = true;
        this.studyFile = false;
      }else {
        this.basicInfo = false;
        this.courseInfo = false;
        this.testList = false;
        this.certificate = false;
        this.studyFile = true;
      }
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      //console.log("上传", fileList);
      this.fileList = fileList;
    },
    handleScollMain() {
      return document.querySelector(".ant-modal-wrap");
    }
  }
};
</script>
<style scoped>
.ant-modal-body{
  padding:10px
}
</style>